export default __webpack_public_path__ + "static/media/foreign-contacts.0d5ffaf7.svg";